import StorageUtils from '@spothero/utils/storage';

window.StorageUtils = StorageUtils;

export default StorageUtils;



// WEBPACK FOOTER //
// ./frontend/src/js/utils/storage.js